var effectSets = new Array();

effectSets["carousel: slide"] = [{ name: "slideLeft", duration: 600 },{ name: "slideRight", duration: 600 }];
effectSets["carousel: slideOver"] = [{ name: "slideOverLeft", duration: 600 },{ name: "slideOverRight", duration: 600 }];

effectSets["slider: big set 1"] = [
  { name: "jalousieLeft", duration: 2000, size: 20, steps: 50 },
  { name: "jalousieRight", duration: 2000, size: 20, steps: 50 },
  { name: "chessBoard", duration: 1000, size: 6, steps: 15 },
  { name: "fade", duration: 1000 },
  { name: "jalousie", duration: 1100, size: 10, steps: 10 },
  { name: "prison", duration: 1100, size: 10, steps: 10 },
  { name: "spiral", duration: 400, size: 10, steps: 20 },
  { name: "pancake", duration: 1000, size: 10, steps: 10 },
  { name: "nails", duration: 800, size: 15, steps: 10 },
  { name: "weed", duration: 1000, size: 10, steps: 10 }
];
effectSets["slider: big set 2"] = [
  { name: "jalousieLeft", duration: 2000, size: 20, steps: 50 },
  { name: "jalousieRight", duration: 2000, size: 20, steps: 50 },
  { name: "chessBoardRandom", duration: 1000, size: 6, steps: 15 },
  { name: "fade", duration: 1000 },
  { name: "jalousie", duration: 1000, size: 10, steps: 10 },
  { name: "prison", duration: 1000, size: 10, steps: 10 },
  { name: "spiral", duration: 400, size: 5, steps: 20 },
  { name: "nails", duration: 800, size: 15, steps: 10 },
  { name: "weed", duration: 1000, size: 10, steps: 10 }
];
effectSets["slider: chessboard"] = [{ name: "chessBoard", duration: 1000, size: 8, steps: 12 }];
effectSets["slider: fade"] = [
  { name: "chessBoard", duration: 1000, size: 10, steps: 15 },
  { name: "fade", duration: 1000 },
  { name: "jalousie", duration: 1100, size: 10, steps: 10 },
  { name: "spiral", duration: 400, size: 10, steps: 20 },
  { name: "pancake", duration: 1000, size: 10, steps: 10 }
];
effectSets["slider: jalousie"] = [{ name: "jalousie", duration: 1100, size: 10, steps: 10 }];
effectSets["slider: nails"] = [{ name: "nails", duration: 1000, size: 10, steps: 10 }];
effectSets["slider: pancakes"] = [{ name: "pancake", duration: 1000, size: 10, steps: 10 }];
effectSets["slider: prison"] = [{ name: "prison", duration: 1000, size: 10 }];
effectSets["slider: sliding"] = [{ name: "slide", duration: 800 },{ name: "slideOver", duration: 800 }];
effectSets["slider: snake"] = [{ name: "spiral", duration: 400, size: 10, steps: 20 }];
effectSets["slider: smoothness"] = [{ name: "jalousieLeft", duration: 2000, size: 20, steps: 50 },{ name: "jalousieRight", duration: 2000, size: 20, steps: 50 }];
effectSets["slider: weed"] = [{ name: "weed", duration: 1000, size: 10, steps: 10 }];

effectSets["zoomer: photoShow"] = [
  { name: "zoomRightTop", duration: 3000, size: 20 },
  { name: "zoomRightBottom", duration: 3000, size: 20 },
  { name: "zoomLeftTop", duration: 3000, size: 20 },
  { name: "zoomLeftBottom", duration: 3000, size: 20 }
];





